import { gql } from "@apollo/client";

export const SUPERVISOR_WORK_QUEUE_QUERY = gql`
  query SUPERVISOR_WORK_QUEUE_QUERY($employeeId: ID!, $originatorId: ID!) {
    supervisorWorkQueue(employeeId: $employeeId, originatorId: $originatorId) {
      id
      incidentNumber
      sealed
      locked
      callTime
      address {
        id
        name
        validAddressAlerts {
          id
          alertType {
            id
            name
            alertLevel
          }
          createdAt
          officer {
            deptAttribute {
              id
              badge
              ori {
                id
                abbreviation
              }
            }
            personalAttribute {
              id
              firstName
              lastName
            }
          }
        }
      }
      classification {
        id
        name
        lowLevelFlag
      }
      personIncidentSpecifics {
        id
        sealed
        juvenile
        yoe
        person {
          id
          aliases {
            id
            target {
              id
              validPersonAlerts {
                id
                alertType {
                  id
                  name
                  alertLevel
                }
              }
            }
          }
          validPersonAlerts {
            id
            alertType {
              id
              name
              alertLevel
            }
            createdAt
            officer {
              deptAttribute {
                id
                badge
                ori {
                  id
                  abbreviation
                }
              }
              personalAttribute {
                id
                firstName
                lastName
              }
            }
          }
        }
      }
      officerIncidentSpecifics {
        id
        primaryOfficer
        officer {
          id
          deptAttribute {
            badge
            ori {
              id
              oriName
              abbreviation
            }
          }
        }
      }
      incidentDetail {
        id
        incidentOffenses {
          id
          offenseViolationPrototype {
            id
            yoe
          }
          suspectVictimAffiliations {
            id
            suspect {
              id
              personalAttribute {
                id
                dob
              }
            }
          }
        }
      }
      incidentArrests {
        id
        arrestee {
          id
          personalAttribute {
            id
            lastName
            firstName
          }
        }
      }
      incidentReview {
        id
        reviewStatus {
          id
          name
          oriId
        }
        approvalStatus {
          id
          name
          oriId
        }
        reviewDate
        keepInOfficerQueue
        keepInQueue
        approvalStatus {
          id
          name
          oriId
        }
        reviewComments
        investigatingOfficer {
          id
          deptAttribute {
            id
            badge
            ori {
              id
              oriName
              abbreviation
            }
          }
        }
      }
    }
  }
`;
